import { Modal, Input, message } from "antd";
import { useState } from "react";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

const { TextArea } = Input;

export const SendMessageModal = ({
    open,
    onCancel,
    talentId,
}: {
    open: boolean;
    onCancel: () => void;
    talentId?: string;
}) => {
    const [messageText, setMessageText] = useState("");
    const [sending, setSending] = useState(false);
    const { token } = useGetUserInfo();

    const handleSend = async () => {
        if (!messageText.trim() || !talentId) return;
        setSending(true);

        try {
            
            const chatResponse = await fetch(`${END_POINT.BASE_URL}/v1/createchatlist`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ to_user_id: talentId }),
            });

            if (!chatResponse.ok) {
                const errorData = await chatResponse.json();
                throw new Error(errorData.error || "Failed to create chat");
            }
            const chatData = await chatResponse.json();

            
            if (!chatData || !chatData.id) {
                console.error("Invalid chat response:", chatData);
                throw new Error("Chat not created or ID missing");
            }

            
            let participants = chatData.participants;


            
            if (!participants || !Array.isArray(participants) || participants.length === 0) {
                console.error("No participants found in chat:", chatData);
                throw new Error("Participants not found");
            }

            
            const talentParticipant = participants.find((p: any) => p.type === "talent" || p.user_id === talentId);
            if (!talentParticipant) throw new Error("Talent participant not found");

            
            const messageResponse = await fetch(`${END_POINT.BASE_URL}/v1/send-talent-message`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    to_user_id: talentParticipant.id || talentParticipant.user_id,
                    text: messageText,
                }),
            });

            if (messageResponse.ok) {
                message.success("Message sent successfully!");
                setMessageText("");
                onCancel();
            } else {
                throw new Error("Failed to send message");
            }
        } catch (err) {
            console.error(err);
            message.error((err as Error).message || "Error sending message");
        } finally {
            setSending(false);
        }
    };



    return (
        <Modal
            title="Send Message"
            open={open}
            onOk={handleSend}
            onCancel={onCancel}
            confirmLoading={sending}
            okText="Send Message"
            okButtonProps={{ disabled: !messageText.trim() }}
        >
            <TextArea
                rows={4}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                placeholder="Type your message here..."
                autoSize={{ minRows: 3, maxRows: 6 }}
            />
            <div className="text-right text-xs text-gray-400 mt-1">
                {messageText.length}/500
            </div>
        </Modal>
    );
};
